<template>
  <div class="email" v-loading="loading">
    <div class="operation-btn">
      <button @click="send('ruleForm')">发送</button>
      <button @click="saveDrafts('ruleForm')">存草稿</button>
      <button @click="$router.back()">返回</button>
    </div>
    <div class="content-box">
      <div class="content-header">
        <div class="header-left">
          <span>发件人</span>
          <span>{{ ruleForm.from }}@{{ emailSuffix }}</span>
        </div>
        <div class="header-right">
          <el-button type="mini" plain @click="handleCC"
            >{{ ccOperation }}抄送</el-button
          >
          <el-button type="mini" plain @click="handleBCC"
            >{{ bccOperation }}密抄</el-button
          >
        </div>
      </div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        label-width="60px"
        :rules="rules"
      >
        <el-form-item label="收件人" prop="to">
          <el-input
            v-model="ruleForm.to"
            size="small"
            v-if="showTo"
            ref="toInput"
            @change="addToList('to')"
          >
            <template slot="append">
              <el-button @click="selectUser('to')">选择</el-button>
            </template>
          </el-input>
          <div class="tag-box" v-else>
            <div class="tag" @click.stop="showInput('to')">
              <el-tag
                size="small"
                closable
                @click.stop
                style="margin-right: 10px"
                @close="handleTagClose('to', item)"
                v-for="item in toTagList"
                :key="item.id"
                >{{ item.name }}</el-tag
              >
            </div>
            <el-button @click="selectUser('to')" size="small">选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="抄送" v-if="showCC" prop="cc">
          <el-input
            v-model="ruleForm.cc"
            size="small"
            v-if="showCCInput"
            ref="ccInput"
            @change="addToList('cc')"
          >
            <template slot="append">
              <el-button @click="selectUser('cc')">选择</el-button>
            </template>
          </el-input>
          <div class="tag-box" v-else>
            <div class="tag" @click.stop="showInput('cc')">
              <el-tag
                size="small"
                closable
                @click.stop
                style="margin-right: 10px"
                @close="handleTagClose('cc', item)"
                v-for="item in ccTagList"
                :key="item.id"
                >{{ item.name }}</el-tag
              >
            </div>
            <el-button @click="selectUser('cc')" size="small">选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="密送" v-if="showBCC" prop="bcc">
          <el-input
            v-model="ruleForm.bcc"
            size="small"
            v-if="showBCCInput"
            ref="bccInput"
            @change="addToList('bcc')"
          >
            <template slot="append">
              <el-button @click="selectUser('bcc')">选择</el-button>
            </template>
          </el-input>
          <div class="tag-box" v-else>
            <div class="tag" @click.stop="showInput('bcc')">
              <el-tag
                size="small"
                closable
                @click.stop
                style="margin-right: 10px"
                @close="handleTagClose('bcc', item)"
                v-for="item in bccTagList"
                :key="item.id"
                >{{ item.name }}</el-tag
              >
            </div>
            <el-button @click="selectUser('bcc')" size="small">选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="主题" prop="subject">
          <el-input
            v-model="ruleForm.subject"
            size="small"
            style="width: 80%"
          ></el-input>
          <el-select v-model="ruleForm.type" size="small" style="width: 20%">
            <el-option label="一般邮件" value="0"></el-option>
            <el-option label="重要邮件" value="1"></el-option>
            <el-option label="非常重要" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mt10">
          <UploadFile @getFileId="addFileId" @subFileId="subFileId" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <vue-ueditor-wrap
            class="ueditor"
            v-model="ruleForm.content"
            :config="myConfig"
          ></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
    </div>

    <!-- userVisible：弹窗可见  closeUserVisiable：关闭弹窗 -->
    <User_Select
      v-if="userVisible"
      ref="userSelect"
      :userVisible="userVisible"
      @closeUserVisiable="resetUserSelect"
      @selectedUsersList="selectedUsersList"
      :rightSelectedUser="setRightUsersList"
    />
  </div>
</template>

<script>
import User_Select from '../user_select'
import UploadFile from '../uploadFile'
export default {
  name: 'email',
  data() {
    return {
      loading: true,
      rules: {
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      ruleForm: {
        from: '', // 发件人
        to: '', // 收件人
        subject: '', // 主题
        cc: '', // 抄送
        bcc: '', // 密送
        type: '0', // 邮件类型
        content: '', // 内容
        attids: [], // 附件id
      },
      myConfig: {
        // 工具栏
        toolbars: [
          [
            'undo', //撤销
            'redo', //重做
            'bold', //加粗
            'indent', //首行缩进
            'italic', //斜体
            'underline', //下划线
            'strikethrough', //删除线
            'formatmatch', //格式刷
            'horizontal', //分隔线
            'removeformat', //清除格式
            'link', //超链接
            'unlink', //取消链接
            'inserttable', //插入表格
            'insertrow', //前插入行
            'insertcol', //前插入列
            'mergeright', //右合并单元格
            'mergedown', //下合并单元格
            'deleterow', //删除行
            'deletecol', //删除列
            'splittorows', //拆分成行
            'splittocols', //拆分成列
            'splittocells', //完全拆分单元格
            'deletecaption', //删除表格标题
            'inserttitle', //插入标题
            'mergecells', //合并多个单元格
            'deletetable', //删除表格
            'fontfamily', //字体
            'fontsize', //字号
            'simpleupload', //单图上传
            'emotion', //表情
            'justifyleft', //居左对齐
            'justifyright', //居右对齐
            'justifycenter', //居中对齐
            'justifyjustify', //两端对齐
            'forecolor', //字体颜色
            'backcolor', //背景色
            'insertorderedlist', //有序列表
            'insertunorderedlist', //无序列表
            'lineheight', //行间距
            'edittip ', //编辑提示
          ],
        ],
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: 'http://localhost:8083/',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL:
          process.env.NODE_ENV === 'production' ? 'UEditor/' : '/UEditor/',
      },
      showCC: false, // 是否显示抄送
      showBCC: false, // 是否显示密送
      showTo: false, // 收件人输入框的显示隐藏
      toTagList: [], // 收件人的tag数组
      showCCInput: false, // 抄送输入框的显示隐藏
      ccTagList: [], // 抄送人的tag数组
      showBCCInput: false, // 密送输入框的显示隐藏
      bccTagList: [], // 密送的tag数组

      emailSuffix: '', // 邮箱后缀

      userVisible: false, // 用户选择弹窗
      currentUser: '', // 当前点击的是哪个用户选择按钮
    }
  },
  methods: {
    /**
     * 获取邮箱后缀
     */
    getSuffix() {
      this.$api.getEmailSuffix({
        onSucess: (res) => {
          if (res.data.errcode == 0) {
            this.emailSuffix = res.data.data
          } else {
            this.$message.warning(res.data.errmsg)
          }
        },
      })
    },

    /**
     * 获取邮件详情
     */
    getDetail() {
      this.loading = true
      let folderId = this.$route.query.folderId
      let id = this.$route.query.id
      this.$api.getEmailDetail(folderId, id, {
        onSucess: (res) => {
          if (res.data.errcode == 0) {
            this.loading = false
            let data = res.data.data

            // 回复的内容
            let str = `
              <p></p><p></p><p>-----------原始邮件------------</p>
              <p>发件人：${data.emailBody.from}</p>
              <p>时间：${this.formDate(data.emailBody.sendDate)}</p>
              <p>收件人：${data.emailBody.to}</p>
              <p></p>`

            if (this.$route.query.type == 2) {
              this.ruleForm.subject = '转发：' + data.emailBody.subject
              this.ruleForm.content = str + data.emailBody.content
            } else if (this.$route.query.type == 1) {
              this.ruleForm.subject = '回复：' + data.emailBody.subject
              this.ruleForm.content = str + data.emailBody.content
              this.toTagList.push({
                name: data.emailBody.from,
                email: data.emailBody.from,
              })
            } else {
              this.ruleForm = {
                from: '', // 发件人
                to: '', // 收件人
                subject: '', // 主题
                cc: '', // 抄送
                bcc: '', // 密送
                type: '0', // 邮件类型
                content: '', // 内容
                attids: [], // 附件id
              }
            }
          }
        },
      })
    },

    /**
     * 点击密送
     */
    handleBCC() {
      this.showBCC = !this.showBCC
      if (!this.showBCC) this.bccTagList = []
    },

    /**
     * 点击抄送
     */
    handleCC() {
      this.showCC = !this.showCC
      if (!this.showCC) this.ccTagList = []
    },

    /**
     * 输入框的显示和隐藏
     */
    showInput(val) {
      if (val == 'to') {
        this.showTo = true
        this.$nextTick(() => {
          this.$refs.toInput.focus()
        })
      } else if (val == 'cc') {
        this.showCCInput = true
        this.$nextTick(() => {
          this.$refs.ccInput.focus()
        })
      } else if (val == 'bcc') {
        this.showBCCInput = true
        this.$nextTick(() => {
          this.$refs.bccInput.focus()
        })
      }
    },

    /**
     * tag标签的删除
     */
    handleTagClose(val, tag) {
      if (val == 'to') {
        this.toTagList.splice(this.toTagList.indexOf(tag), 1)
      } else if (val == 'cc') {
        this.ccTagList.splice(this.ccTagList.indexOf(tag), 1)
      } else if (val == 'bcc') {
        this.bccTagList.splice(this.bccTagList.indexOf(tag), 1)
      }
    },

    /**
     * 添加到数组队列中
     */
    addToList(val) {
      if (val == 'to') {
        // 收件人
        this.toTagList.push({
          name: this.ruleForm.to,
          email: this.ruleForm.to,
        })
        this.ruleForm.to = ''
        this.showTo = false
      } else if (val == 'cc') {
        this.ccTagList.push({
          name: this.ruleForm.cc,
          email: this.ruleForm.cc,
        })
        this.ruleForm.cc = ''
        this.showCCInput = false
      } else if (val == 'bcc') {
        this.bccTagList.push({
          name: this.ruleForm.bcc,
          email: this.ruleForm.bcc,
        })
        this.ruleForm.bcc = ''
        this.showBCCInput = false
      }
    },

    /**
     * 将值写入输入框
     */
    selectedUsersList(arr) {
      if (this.currentUser == 'to') {
        this.toTagList = arr
      } else if (this.currentUser == 'cc') {
        this.ccTagList = arr
      } else if (this.currentUser == 'bcc') {
        this.bccTagList = arr
      }
    },

    /**
     * 点击选中哪一个按钮
     */
    selectUser(val) {
      this.userVisible = true
      this.currentUser = val
    },

    /**
     * 用户选择弹窗关闭的重置数据
     */
    resetUserSelect() {
      this.userVisible = false
      this.$refs.userSelect.selectedUsers = [] // 中间已选中的数据清空
      this.$refs.userSelect.selectedUsersList = [] // 右侧已选中的数据清空
      this.$refs.userSelect.deptUser = [] // 中间显示的数据为空
      this.$refs.userSelect.searchData = [] // 中间显示的数据为空
      this.$refs.userSelect.searchValue = '' // 搜索框的值重置
    },

    /**
     * 获取附件id
     */
    addFileId(id) {
      this.ruleForm.attids.push(id + '')
    },

    /**
     * 移除附件的id
     */
    subFileId(id) {
      this.ruleForm.attids.splice(this.ruleForm.attids.indexOf(id), 1)
    },

    /**
     * 发送邮件
     */
    send(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let folderId = this.$store.state.inboxId

          let toArr = []
          if (this.toTagList.length > 0) {
            this.toTagList.map((item) => toArr.push(item.email)) // 收件人
          }

          let ccArr = []
          if (this.ccTagList.length > 0) {
            this.ccTagList.map((item) => ccArr.push(item.email)) // 收件人
          }

          let bccArr = []
          if (this.bccTagList.length > 0) {
            this.bccTagList.map((item) => bccArr.push(item.email)) // 收件人
          }
          let params = {
            ...this.ruleForm,
            from: this.ruleForm.from + '@' + this.emailSuffix,
            to: toArr.length > 0 ? toArr.join(',') : '',
            cc: ccArr.length > 0 ? ccArr.join(',') : '',
            bcc: bccArr.length > 0 ? bccArr.join(',') : '',
          }

          this.$api.sendEmail(folderId, params, {
            onSucess: (res) => {
              if (res.data.errcode == 0) {
                this.$router.replace('/tip')
              } else {
                this.$message.warning(res.data.errmsg)
              }
            },
          })
        } else {
          return false
        }
      })
    },

    /**
     * 存草稿
     */
    saveDrafts(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let folderId = this.$store.state.draftsId

          let toArr = []
          if (this.toTagList.length > 0) {
            this.toTagList.map((item) => toArr.push(item.email)) // 收件人
          }

          let ccArr = []
          if (this.ccTagList.length > 0) {
            this.ccTagList.map((item) => ccArr.push(item.email)) // 收件人
          }

          let bccArr = []
          if (this.bccTagList.length > 0) {
            this.bccTagList.map((item) => bccArr.push(item.email)) // 收件人
          }
          let params = {
            ...this.ruleForm,
            from: this.ruleForm.from + '@' + this.emailSuffix,
            to: toArr.length > 0 ? toArr.join(',') : '',
            cc: ccArr.length > 0 ? ccArr.join(',') : '',
            bcc: bccArr.length > 0 ? bccArr.join(',') : '',
          }

          this.$api.sendEmail(folderId, params, {
            onSucess: (res) => {
              if (res.data.errcode == 0) {
                this.$message.success('邮件已存储到草稿箱!')
              } else {
                return this.$message.warning(res.data.errmsg)
              }
            },
          })
        } else {
          return false
        }
      })
    },

    /**
     * 格式化时间
     */
    formDate(value) {
      let date = new Date(value)
      let year = date.getFullYear()
      let month =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : '0' + date.getMonth() + 1
      let day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
      let hour = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours()
      let minute =
        date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes()
      let second =
        date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds()
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      )
    },
  },
  created() {
    this.ruleForm.from = JSON.parse(sessionStorage.getItem('emailUser')).account
    this.getSuffix()

    this.loading = false

    let type = this.$route.query.type

    // 判断是写邮件还是其他页面跳转过来
    if (type == 1 || type == 2) {
      this.getDetail()
    }
  },
  computed: {
    /**
     * 添加删除抄送
     */
    ccOperation() {
      let oper = ''
      if (this.showCC) {
        oper = '删除'
      } else {
        oper = '添加'
      }
      return oper
    },
    /**
     * 添加删除密送
     */
    bccOperation() {
      let oper = ''
      if (this.showBCC) {
        oper = '删除'
      } else {
        oper = '添加'
      }
      return oper
    },
    /**
     * 将值传给子组件
     */
    setRightUsersList() {
      let list = []
      if (this.currentUser == 'to') {
        list = this.toTagList
      } else if (this.currentUser == 'cc') {
        list = this.ccTagList
      } else if (this.currentUser == 'bcc') {
        list = this.bccTagList
      }
      return list
    },
  },
  components: {
    User_Select,
    UploadFile,
  },
}
</script>
